import {
  MAINNET_PERP_METADATA_BY_PRODUCT_ID,
  TESTNET_PERP_METADATA_BY_PRODUCT_ID,
} from '../commonPerpMetadataByProductId';

export const ABSTRACT_PERP_METADATA_BY_PRODUCT_ID =
  MAINNET_PERP_METADATA_BY_PRODUCT_ID;

export const ABSTRACT_TESTNET_PERP_METADATA_BY_PRODUCT_ID =
  TESTNET_PERP_METADATA_BY_PRODUCT_ID;
